import {
  ProjectStatusDisplayName,
  ProjectStatusEnum,
} from "pmt-types/src/enums/ProjectStatus.ts";
import { Project } from "pmt-types/src/models/Project.ts";
import { Source } from "pmt-types/src/models/Source.ts";
import { useNavigate } from "react-router-dom";
import SearchPage from "../../components/search/searchPage.tsx";
import formatDateString from "../../utils/formatDateString.ts";

export default function ProjectsList() {
  const navigate = useNavigate();

  return (
    <SearchPage<Project>
      route="projects"
      resultsColumnDef={[
        {
          accessorKey: "name",
          id: "name",
          cell: (info) => info.getValue(),
          header: "Project",
          minSize: 400,
        },
        {
          accessorKey: "status",
          id: "status",
          cell: (info) =>
            ProjectStatusDisplayName[info.getValue() as ProjectStatusEnum],
          header: "Status",
          minSize: 100,
        },
        {
          accessorKey: "source",
          id: "source",
          cell: (info) => (info.getValue() as Source)?.name,
          header: "Source",
        },
        {
          accessorKey: "updatedDate",
          id: "updatedDate",
          cell: (info) => formatDateString(info.getValue() as string),
          header: "Last Updated",
        },
        {
          id: "view",
          cell: (info) => (
            <div className="flex items-center justify-around mr-4">
              <a
                className="ml-2 text-sm font-medium text-sky-500 hover:text-sky-700 cursor-pointer"
                onClick={() => {
                  navigate(
                    `/sources/${info.row.original.source.id}/projects/${info.row.original.id}/details`,
                  );
                }}
              >
                View
              </a>
              <a
                className="ml-2 text-sm font-medium text-sky-500 hover:text-sky-700 cursor-pointer"
                onClick={() => {
                  navigate(
                    `/sources/${info.row.original.source.id}/projects/${info.row.original.id}?return=search`,
                  );
                }}
              >
                Edit
              </a>
            </div>
          ),
          header: "",
          maxSize: 100,
        },
      ]}
    />
  );
}
